import React from "react";
export const PersistorContext = React.createContext(null);
